import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface AlertOptions {
	message?: string;
	successButtonText?: string;
	failureButtonText?: string;
	successButtonColor?: string;
	failureButtonColor?: string;
	showFailureButton?: boolean;
}

@Component({
	selector: 'rpshared-alert-dialog',
	templateUrl: './alert-dialog.component.html',
})
export class AlertDialogComponent implements OnInit {
	message = 'Are you sure?';
	successButtonText = 'OK';
	failureButtonText = 'Cancel';
	successButtonColor = 'primary';
	failureButtonColor = 'warn';
	showFailureButton = true;

	constructor(
		private alertDialogRef: MatDialogRef<AlertDialogComponent>,
		@Inject(MAT_DIALOG_DATA) private data: AlertOptions
	) {}

	ngOnInit() {
		this.message = this.data.message || this.message;
		this.successButtonText =
			this.data.successButtonText || this.successButtonText;
		this.failureButtonText =
			this.data.failureButtonText || this.failureButtonText;
		this.successButtonColor =
			this.data.successButtonColor || this.successButtonColor;
		if (this.data.showFailureButton === false) {
			this.showFailureButton = this.data.showFailureButton;
		}
	}

	successClose() {
		this.alertDialogRef.close(true);
	}

	failureClose() {
		this.alertDialogRef.close(false);
	}
}
